import styled from 'styled-components'
import { colors } from '../../theme'

export const ToggleWrapper = styled.div`
  margin: 8px 0 16px;
`

export const SemDados = styled.p`
  color: ${colors.grey900};
  padding: 16px 0;
`

export const FeedbackBtn = styled.button<{ ativo?: boolean }>`
  border: none;
  background: none;
  cursor: pointer;
  font-size: 16px;
  padding: 0 4px;
  line-height: 1;
  opacity: ${({ ativo }) => (ativo ? 1 : 0.3)};
`

export const ListaProdutos = styled.ul`
  margin: 0;
  padding: 8px 16px;
  list-style: disc inside;
  color: ${colors.grey900};
  font-size: 13px;

  li {
    padding: 2px 0;
  }
`
